/** Minimal session fields required to evaluate editability (WCO-3226). */
export interface SessionEditabilityInput {
  status: string;
  /** Populated by PUT guard; optional on GET payloads. */
  has_inbound_transfer?: boolean;
  /** Present on GET list/detail when session has an inbound transfer link. */
  linked_transfer_number?: string | null;
}

function sessionHasInboundTransfer(session: SessionEditabilityInput): boolean {
  if (session.has_inbound_transfer != null) return session.has_inbound_transfer;
  return Boolean(session.linked_transfer_number);
}

/** Session is editable when pending, or received without an inbound transfer. */
export function isSessionEditable(session: SessionEditabilityInput): boolean {
  return (
    session.status === 'pending' ||
    (session.status === 'received' && !sessionHasInboundTransfer(session))
  );
}
